import { useTranslation } from 'react-i18next'
import sortBy from 'lodash/sortBy'

export function useSortableColumnsOptions (sortableColumns, additionalParams = []) {
  const { t } = useTranslation()
  let options = []

  sortableColumns.forEach((columnName) => {
    let label = columnName

    if (columnName === 'external_id') {
      label = t('common.sortTicketIdLabel')
    }

    options.push({
      value: columnName,
      label: label.replaceAll('_', ' ').toUpperCase(),
    })
  })

  if (additionalParams.length) {
    options.push(...additionalParams)
  }

  options = sortBy(options, ['label'])

  return options
}
